var exports = {
  "d": "affirmative__E8s2fT",
};

module.exports = exports;
